import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const Loader = () => {
  return (
    <div
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginTop: 125
      }}
    >
      <CircularProgress style={{ color: '#3b424d' }} thickness={2} size={75} />
    </div>
  )
}

export { Loader }



// WEBPACK FOOTER //
// ./src/components/common/Loader.js